export default __webpack_public_path__ + "static/media/png-icon.5fbb80b4.svg";